import { SignUp as ClerkSignUp } from '@clerk/clerk-react';

export function SignUp() {
  return (
    <div className="auth-container">
      <div className="onboarding-logo">
        <div className="onboarding-logo-text">CLAWZEMPIC</div>
        <div className="onboarding-logo-sub">The Inference Diet</div>
      </div>
      <ClerkSignUp
        routing="hash"
        afterSignUpUrl="/auth-callback"
        signInUrl="/sign-in"
      />
    </div>
  );
}
